import Vue from "vue";

// events instance.
export default new Vue();
